import { Card, CardMedia } from "@mui/material";
import { getTheme, PlatformDialog } from "../../platform-style";
import React from "react";

interface PDFViewerProps {
  open: boolean;
  title?: string;
  onClose: () => void;
  content: string;
  contentHeight?: number | string;
  contentWidth?: number | string;
}

export function PDFViewer({
  open,
  title = "PDF Viewer",
  onClose,
  content,
  contentHeight = 500,
  contentWidth = "100%",
}: Readonly<PDFViewerProps>) {
  return (
    <PlatformDialog
      open={open}
      title={title}
      closeLabel={"close"}
      onClose={onClose}
      maxWidth={1100}
    >
      <Card>
        <CardMedia
          component={"iframe"}
          src={content}
          sx={{
            height: contentHeight,
            width: contentWidth,
            colorScheme: "inherit",
            backgroundColor: getTheme().palette?.background?.paper,
          }}
        />
      </Card>
    </PlatformDialog>
  );
}
